import React, { useEffect, useState } from "react";
import api from "../api";

function AdminPage() {
  const [tenants, setTenants] = useState([]);
  const [expandedTenant, setExpandedTenant] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTenants();
  }, []);

  const fetchTenants = async () => {
    try {
      const res = await api.get("/tenants");
      setTenants(res.data);
    } catch (err) {
      setError("Failed to fetch tenants.");
      console.error("Fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (tenantId, statKey) => {
    setTenants(prev =>
      prev.map(t =>
        t.id === tenantId
          ? {
              ...t,
              stats: {
                ...t.stats,
                [statKey]: !t.stats?.[statKey]
              }
            }
          : t
      )
    );
    // TODO: Optionally send update to backend
  };

  const toggleExpand = (tenantId) => {
    setExpandedTenant(expandedTenant === tenantId ? null : tenantId);
  };

  return (
    <div className="p-6 text-white">
      <h1 className="text-3xl mb-4">Admin Portal</h1>

      {loading && <p className="text-gray-400">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {tenants.map((tenant) => (
        <div key={tenant.id} className="mb-4 border rounded-lg p-4 bg-gray-800">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">{tenant.name}</h2>
            <button
              onClick={() => toggleExpand(tenant.id)}
              className="bg-green-600 hover:bg-green-700 px-3 py-1 rounded"
            >
              {expandedTenant === tenant.id ? "Hide Settings" : "Edit Settings"}
            </button>
          </div>

          {expandedTenant === tenant.id && (
            <div className="mt-4 space-y-2">
              <p className="text-sm text-gray-300">Select which stats to show:</p>
              <div className="grid grid-cols-2 gap-4">
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={tenant.stats?.calls_per_did || false}
                    onChange={() => handleToggle(tenant.id, "calls_per_did")}
                  />
                  <span>Calls per DID</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={tenant.stats?.missed_calls || false}
                    onChange={() => handleToggle(tenant.id, "missed_calls")}
                  />
                  <span>Missed Calls</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={tenant.stats?.unreturned_calls || false}
                    onChange={() => handleToggle(tenant.id, "unreturned_calls")}
                  />
                  <span>Unreturned Missed Calls</span>
                </label>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default AdminPage;

